import Vue from "vue/dist/vue.esm";

// race info のデータを元に生成するコンポーネント

// 七賭け投票の出走表下に表示する並び予想
// 排列の数だけ並列に表示可能
var keirinNarabiRow = Vue.extend({
  data: function() {
    return {}
  },
  template: `
    <table v-if="narabi.sequences" class="table mb20">
      <tr>
        <th v-if="titlecheck">
          <span>周回予想</span><br>
          <span v-if="narabi.updated_at != ''">{{narabi.updated_at}}</span>
        </th>
        <th v-else>
          <span class="text-red-highlight">選手紹介並び</span><br>
          {{narabi.updated_at}}
        </th>
        <td>
          <table class="table table-border-none" border="0">
            <tr v-for="row in rows" v-if="hasSyaban(row)">
              <td v-for="col in row">
                <span v-if="col != 'x'" class="square square-slim" :class="'bg-' + col">{{col}}</span>
                <span v-else class="p10"></span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr v-if="narabi.comment != ''">
        <td colspan="2">
          <span>＜コメント＞</span><br>
          {{narabi.comment}}
        </td>
      </tr>
    </table>
  `,
  methods: {
    hasSyaban: function(arr) {
      // x空白を決めとしてx以外の要素が配列に含まれているかのチェック
      return arr.some(function(e, i, a) {
        return e != 'x';
      });
    }
  },
  computed: {
    rows: function() {
      var rows = [];
      
      for (var i=0; i<this.narabi.sequences.length; i++) {
        rows.push(this.narabi.sequences[i].split(''));
      }
      
      return rows;
    },
    titlecheck: function() {
      if (this.narabi.kaomise == 'before'){
        return true;
      } else {
        return false;
      }
    },
    athletes: function() {
      return this.raceInfo.race_athletes;
    }
  }
});

// keirin jushou の投票、確認画面でのみ使用するコンポーネント
var keirinNarabiRowDetail = Vue.extend({
  data: function() {
    return {
      isClickable: false
    }
  },
  template: `
    <div v-if="narabi.sequences">
      <table class="table table-border-none" border="0" v-if="hasValidData && rows.length > 0">
        <tr v-for="(row, rowIndex) in rows" v-if="hasSyaban(row)">
          <td v-for="col in row" class="text-center">
            <div v-if="col != 'x' && rowIndex == 0" class="balloon balloon-top mb5" :class="[{ 'is-clickable': isClickable && athletes[col].on_sale }, { 'is-not-allowed balloon-disabled': !athletes[col].on_sale }]" @click="addSyabanToEditCart(raceInfo.box.race_num, col)"><span class="balloon-text-vertical">{{athletes[col].name}}</span></div>
            <span v-if="col != 'x'" class="square" :class="[{'is-disabled': !athletes[col].on_sale}, 'bg-' + col]">{{col}}</span>
            <span v-else class="p10"></span>
            <div v-if="col != 'x' && rowIndex == 1" class="balloon balloon-bottom mt5" :class="[{ 'is-clickable': isClickable && athletes[col].on_sale }, { 'is-not-allowed balloon-disabled': !athletes[col].on_sale }]" @click="addSyabanToEditCart(raceInfo.box.race_num, col)"><span class="balloon-text-vertical">{{athletes[col].name}}</span></div>
          </td>
        </tr>
      </table>
      <p v-else>予想並びデータはありません。</p>
    </div>
  `,
  methods: {
    addSyabanToEditCart: function(race_num, syaban) {
      var syaban = syaban.toString();
      if (this.raceInfo.race_athletes[syaban].on_sale) {
        this.$parent.$emit('addSyaban', race_num, syaban);
      }
    },
    hasSyaban: function(arr) {
      // x空白を決めとしてx以外の要素が配列に含まれているかのチェック
      return arr.some(function(e, i, a) {
        return e != 'x';
      });
    }
  },
  computed: {
    rows: function() {
      var rows = [];
      
      for (var i=0; i<this.narabi.sequences.length; i++) {
        rows.push(this.narabi.sequences[i].split(''));
      }
      
      return rows;
    },
    athletes: function() {
      return this.raceInfo.race_athletes;
    },
    // 空以外のデータを持っているのかの判定
    hasValidData: function() {
      var flg = false;
      
      for (var i=0; i<this.rows.length; i++) {
        if (this.rows[i].length > 0) {
          flg = true;
          
          return flg
        }
      }
      
      return flg;
    }
  }
});

export default {
  keirinNarabiRow,
  keirinNarabiRowDetail
}
